export const SET_THEME = (state, theme) => {
  state.current = theme;
};
